import {useCallback, useEffect, useState} from 'react';
import { useHistory } from "react-router-dom";
import * as Types from "../../App";
import { getCookie } from "../../data/Cookies";
import useUserData from "../../hooks/useUserData.js";
import { Container, Grid } from '@mui/material';
import SummaryCard from '../widgets/SummaryCard';
import ChargingProgress from '../widgets/ChargingProgress';
import EmissionsIndicator from '../widgets/EmissionsIndicator';
import axios from 'axios';
import ProgressGraph from '../widgets/ProgressGraph';
import toast, { Toaster } from 'react-hot-toast';
import NavigationBar from '../widgets/NavigationBar';

import '../../styles/chargingSession.scss';
import { planEV } from '../../assets/profile-steering/ProfileSteering';
import useProfileData from '../../hooks/useProfileData';
import { ChargingMode } from '../../data/models/ChargingMode';
import { getEmissions } from '../../assets/profile-steering/PriceEmissions';


/**
 * Type for ChargingSession component props.
 */
interface ChargingSessionProps {
    settings: Types.SessionType;
}

/**
 * ChargingSession component of the web application. 
 * @param settings Type of Charging Session based on the user input from Schedule page.
 */

export default function ChargingSession({settings}: ChargingSessionProps) {

    const history = useHistory();
	//Gerwin stuff
	// Retrieve info from server
	const { userData, getUserData } = useUserData();
    const { profileData, getProfileData } = useProfileData();
	let id = getCookie("id");
    const [finished, setFinished] = useState<boolean>(false);
    
    /**
     * Departure time
     * @param settings.hour     Hour set by user for departure.
     * @param settings.minutes  Minutes set by user for departure.
     */
    const [time, setTime] = useState<string>(settings.hour + " : " + settings.minutes);
    const [CO2, setCO2] = useState(settings.CO2);
    const [planning, setPlanning] = useState<{name: string, charge: number}[]>(settings.planning);

    const handleClick = useCallback(() => {
        
        // if button===finished, the user goes to Feedback page.
        if (finished) {
            history.push("/feedback");
        }  else {

            //modal becomes true, pop-up appears.
            //setModal(!modal);
        }

        history.push("/modifySession");
    }, [history, finished]);//, modal]);


    const handleCancel = useCallback(() => {
        axios.post('https://slimpark.roaming.utwente.nl:3001/cancel', {
            "cancelation": true,
            "id": getCookie("id"),
        })
            .then(function (response) {
                console.log(response);
            })
            .catch(function (error) {
                console.log(error);
            });

        history.push('/')
    }, [history])

    // Updates the value of progress bar.
	// Get data info from server
	useEffect(() => {
		getUserData(id);
        getProfileData()
		const interval = setInterval(() => {
			getUserData(id)
        }
			, 10000);
        return () => {
            clearInterval(interval);
        }
    }, [])

    /**
     * Progress bar is at 100%, the charging has finished.
     */
    useEffect(() => {
        if(userData.session_progress === 100){
            setFinished(true);
        }
    }, [userData, finished])

	useEffect(() => {
		if (!finished) {
			if (userData.session_minutes > 9){
				setTime(userData.session_hours+":"+userData.session_minutes);
			} else {
				setTime(userData.session_hours+":0"+userData.session_minutes);
			}
		}
    }, [userData])

    useEffect(() => {
        if (finished) notifyChargingCompleted();
    }, [finished])
	
      // Toast for informing the user the car is charging
      const notify = () => toast('Charging in progress', {
        id: 'ChargingToast',    
        duration: 6000,
        position: 'top-center',
    
        icon: '🔋',

        style: {
            maxHeight: '40px',
            border: '1px solid green',
            padding: '16px',
            color: 'black',
          },
      });

      const notifyChargingCompleted = () => toast('Charging completed', {
        id: 'ChargingToast',    
        duration: 6000,
        position: 'top-center',
    
        icon: '✅',

        style: {
            maxHeight: '40px',
            border: '1px solid green',
            padding: '16px',
            color: 'black',
          },
      });

    // makes sure that the charging notification only displayed when schedule is previous page 
    // and not on every reload
    useEffect(() => {
        if (localStorage.getItem('firstChargeNotification') === 'true') {
            notify();
            localStorage.removeItem('firstChargeNotification');
        }
	}, []);

    useEffect(() => {
        if (settings.CO2 === 0 && settings.planning.length === 0) {
            axios.get('https://slimpark.roaming.utwente.nl:3001/getStatus')
                .then((res) => {
                    let plan = res.data[userData.id]?.planning.reverse()
                    let intervals = profileData.intervals.slice(0,profileData.intervals.indexOf(time))
                    let zipped = intervals.map((v,k) => ({name: v, charge: plan[k]}))
                    setPlanning(zipped)
                })
            // TODO: Get CO2 Emmissions from API
            // setCO2(0)
        }
    }, [profileData])

    return(
      <Container className='chargingSession'>

        <Toaster/>

        <Grid
            sx = {{width: "96vw", height: "100%"}}
            container
            spacing={2}
            direction = "row">

            <Grid item xs = {12} marginTop={'1.5rem'}>
                <SummaryCard
                    energy={Math.round(userData.session_energy/100)/10} 
                    mode={userData.session_modus?.split(" ")[0]} 
                    time={time} 
                    handleEdit={handleClick}
                    handleCancel={handleCancel}
                />
            </Grid>
            <Grid item xs={6}>
                <ChargingProgress percentage={userData.session_progress}/>
            </Grid>
            <Grid item xs = {6}>
                {/* Get CO2 from API (Create in data structure) */}
                <EmissionsIndicator CO2={(642 * userData.session_energy_target) -  CO2} />                
            </Grid>
            <Grid item xs={12}>
                <ProgressGraph planning={planning} />
            </Grid>
            <Grid item xs = {12} sx = {{minHeight: "7%"}}>
                <NavigationBar/>
            </Grid>
        </Grid>
      </Container>



    );
};
